import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalConfirmationContainer,
  ModalConfirmationHeader,
  ModalConfirmationFooter,
  ModalConfirmationContent,
  ModalActions,
} from '../../components/modal';
import { TextButton, WarningButton } from '../../components/button';

type Props = {
  closeModal: () => void;
  isOpen: boolean;
  deleteWatcher: Function;
};

export class DeleteWatcherModal extends React.Component<Props> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  validateDeleteWatcher = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { deleteWatcher, closeModal } = this.props;
    event.preventDefault();
    deleteWatcher();
    closeModal();
  };

  cancelDeleteWatcher = (event?: React.MouseEvent) => {
    const { closeModal } = this.props;
    if (event) {
      event.preventDefault();
    }
    closeModal();
  };

  render() {
    const { isOpen } = this.props;
    return (
      <ModalConfirmationContainer
        onRequestClose={this.cancelDeleteWatcher}
        isOpen={isOpen}
      >
        <ModalConfirmationHeader
          onClose={this.cancelDeleteWatcher}
          title="Supprimer l'alerte ?"
        />
        <ModalConfirmationContent>
          <FormattedMessage id="watchers/delete/DeleteWatcherModal.tsx/1" />
        </ModalConfirmationContent>

        <ModalConfirmationFooter>
          <ModalActions>
            <TextButton onClick={this.cancelDeleteWatcher}>
              <FormattedMessage id="watchers/delete/DeleteWatcherModal.tsx/2" />
            </TextButton>
            <WarningButton
              onClick={this.validateDeleteWatcher}
              dataName="validate-delete-watcher"
            >
              <FormattedMessage id="watchers/delete/DeleteWatcherModal.tsx/3" />
            </WarningButton>
          </ModalActions>
        </ModalConfirmationFooter>
      </ModalConfirmationContainer>
    );
  }
}
